import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import styles from '@src/styles/components/menu-desktop.scss';
import translationManager from '@src/js/TranslationManager';
import Input from '../Form/Input';
import MenuPopup from './MenuPopup';
import Button from '../Base/Button';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class MenuSearchMobile extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            searchPlaceholderI18Tag: null,
            isSearchProcessing: false,
            showMoreButtonText: null,
            showMoreCount: null,
            showMoreLink: null,
            results: null,
        };
    }

    static get propTypes() {

        return {
            height: PropTypes.number,
            onClose: PropTypes.func,
        };
    }

    componentDidMount() {

        translationManager
            .get('header.search.placeholder')
            .then((searchPlaceholderI18Tag) => this.setState({ searchPlaceholderI18Tag }));
    }

    render() {

        const { height, onClose } = this.props;

        return (

            <>

                <div className={ css('absolute left-0 right-0 top-0 bg-white z-index-topmost') } style={{ height: height - 1 }}>
                    <div className={ css('container flex items-center px-4 wide:px-0 h-full') }>
                        <div className={ css('flex-1 flex gap items-center') }>{ this.renderSearchInput() }</div>
                        <div className={ css('flex cursor-pointer select-none') } onClick={ () => onClose() }>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="13.4141" y="12.0001" width="20" height="2" transform="rotate(45 13.4141 12.0001)" fill="#0F1011"/><rect x="12" y="26.1422" width="20" height="2" transform="rotate(-45 12 26.1422)" fill="#0F1011"/></svg>
                        </div>
                    </div>
                </div>

                {
                    AdaptiveTrait.isMobile()
                        ? this.renderResultsMobile()
                        : this.renderResultsDesktop()
                }

            </>
        );
    }

    renderSearchInput() {

        const { searchPlaceholderI18Tag, isSearchProcessing } = this.state;

        return (
            <>
                {
                    isSearchProcessing
                        ? this.renderPendingIcon()
                        : this.renderSearchIcon()
                }

                <Input
                    ref={ (el) => this.handleInputInit(el) }
                    placeholder={ searchPlaceholderI18Tag }
                    className={ css('!h-full !border-none px-1 text-normal title4 m-0') }
                    onInput={ () => this.handleInputText() }
                    onChange={ (e) => this.handleSearch(e) }
                />
            </>
        );
    }

    renderSearchIcon() {

        return <div className={ css('icon-search title2 text-muted text-normal') } />;
    }

    renderPendingIcon() {

        return <div className={ css('icon-spinner animate-spin title2 text-muted text-normal') } />;
    }

    renderResultsMobile() {

        // eslint-disable-next-line object-curly-newline
        const { results, isSearchProcessing } = this.state;

        if (!results || results.length < 1)
            return <MenuPopup />;

        return (
            <MenuPopup>
                <div className={ css(isSearchProcessing ? 'grayscale' : undefined) }>

                    { this.renderResults() }

                    {/* pending overlay */}
                    {
                        isSearchProcessing
                            ? <div className={ css('absolute inset-0 animate-pulse bg-white') } />
                            : null
                    }

                </div>
            </MenuPopup>
        );
    }

    renderResultsDesktop() {

        // eslint-disable-next-line object-curly-newline
        const { results, isSearchProcessing } = this.state;

        if (!results || results.length < 1 || isSearchProcessing)
            return null;

        return (
            <div className={ css('menu-popup !flex', styles) }>
                <div className='flex flex-wrap w-full'>
                    { this.renderResults() }
                </div>
            </div>
        );
    }

    renderResults() {

        // eslint-disable-next-line object-curly-newline
        const { results, showMoreButtonText, showMoreCount, showMoreLink } = this.state;

        return (
            <>
                { results.map(({ phrase, tag }, index) => this.renderResultItem(phrase, tag, index)) }

                <div className={ css('p-4 flex justify-center w-full') }>
                    <Button style='outline' className={ css('py-2') } onClick={ () => this.openLink(showMoreLink) }>
                        <span>{ showMoreButtonText }</span>
                        <span className={ css('!badge-primary-opacity rounded-full ml-2') }>{ showMoreCount }</span>
                    </Button>
                </div>
            </>
        );
    }

    // eslint-disable-next-line camelcase
    renderResultItem({ text, text_short, url }, tag, index) {

        /**
         * @todo: tag has legacy css code
         */

        return (
            <div className={ css('w-full border-b-base p-4 flex mobile:flex-wrap justify-between desktop:py-2 items-center') } key={ index }>

                {/* result */}
                <div className={ css('w-full mb-3 cursor-pointer desktop:mb-0 desktop:!flex-auto') } onClick={ () => this.openLink(url) }>
                    <div className={ css('w-full title3 desktop:title4 text-normal mt-0') } dangerouslySetInnerHTML={{ __html: text }}/>
                    <div className={ css('w-full title4 text-normal text-muted')} dangerouslySetInnerHTML={{ __html: text_short }} />
                </div>

                {/* tag */}
                <div className={ css('w-full desktop:!flex-1 whitespace-nowrap') }>
                    <a className={ `search-block__tag search-tag_${tag.alias}` } href={ tag.url }>{ tag.name }</a>
                </div>

            </div>
        );
    }

    handleInputInit(el) {

        if (el)
            el.nodes.input.focus();
    }

    handleInputText() {

        this.setState({ isSearchProcessing: true });
    }

    handleSearch(e) {

        const
            query = e.target.value,
            slug = translationManager.locale;

        fetch(`/api/header/search.json?country_slug=${slug}&text=${query}`)
            .then((response) => response.json())
            .then((response) => {

                this.setState({
                    isSearchProcessing: false,
                    showMoreCount: response.count,
                    showMoreButtonText: response.more_text,
                    showMoreLink: response.search_url,
                    results: response.items,
                });
            });
    }

    openLink(link) {

        window.location.href = link;
    }

}